import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  LogoSideNav: {
    height: 72,
  },
  LogoSquare: {
    height: 48,
  },
}));
